import { AuthenticationService } from './authentication.service';
import { Agent } from '../../shared/models/transactions-model';
import { StringHelper } from '../helpers/strings.helper';
import {
	AddLocationRequestModel,
	AgentLocationModel,
	AgentTerminalInfoModel,
	AggregatorAgentModel,
	AggregatorModel,
	AggregatorRequestModel,
	AssignedSerialNoModel,
	AssignTerminalRequestModel,
	ElligibleAggregatorObjectModel,
	FeesModel,
	NewAssignTerminalRequestModel,
} from '../../shared/models/aggregator.model';
import { AppConfig } from '../../shared/config/app-config';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CashoutPeriodSummary } from '../../shared/models/cashout-period-summary';
import { BrmAccountSummary } from '../../shared/models/brm-account-summary';

@Injectable({
	providedIn: 'root',
})
export class AggregatorService {
	isReportSearch: boolean;
	private _pinModalDestroy = new Subject<any>();
	_pinModalDestroy$ = this._pinModalDestroy.asObservable();
	private _reportModalDestroy = new Subject<any>();
	_reportModalDestroy$ = this._reportModalDestroy.asObservable();
	private _reloadComponent = new Subject<any>();
	_reloadComponent$ = this._reloadComponent.asObservable();
	private reportType: string;
	private aggregator: string;
	private dateRange: any;
	private displayAccountBalance: any[];
	private isAggregatorCashout: boolean;
	private persistFlag: any;
	private completedModal: number;
	private userContext;
	private showBalance: boolean;
	private cashoutSuccessful: boolean;
	private showBalances: any[];
	private pricingPlanRequestData: any = null;

	private selectedAgentData: Agent;

	constructor(private apiClientHelper: ApiClientHelper, private authService: AuthenticationService, public config: AppConfig) {}

	get context() {
		let context = this.authService.getContextUser();
		if (context === 'area-manager') {
			context = 'area-managers';
		}
		return context;
	}

	get agentData() {
		return this.selectedAgentData;
	}

	set agentData(data) {
		this.selectedAgentData = data;
	}

	setShowBalance(balance) {
		this.showBalance = balance;
	}

	setCashoutSuccess(success) {
		this.cashoutSuccessful = success;
		this._reloadComponent.next(success);
	}

	setPricingPlanRequestData(data) {
		this.pricingPlanRequestData = data;
	}

	getPricingPlanRequestData() {
		return this.pricingPlanRequestData;
	}

	getCashoutSuccess() {
		return this.cashoutSuccessful;
	}

	getShowBalance() {
		return this.showBalance;
	}

	setShowBalances(balances) {
		this.showBalances = balances;
	}

	getShowBalances() {
		return this.showBalances;
	}

	setReportType(report) {
		this.reportType = report;
	}

	getReportType() {
		return this.reportType;
	}

	setAggregator(aggregator) {
		this.aggregator = aggregator;
	}

	getAggregator() {
		return this.aggregator;
	}

	setDateRange(range) {
		this.dateRange = range;
	}

	getRange() {
		return this.aggregator;
	}

	setIsReportSearch(search) {
		this.isReportSearch = search;
	}

	getIsReportSearch() {
		return this.isReportSearch;
	}

	setContext(context) {
		this.userContext = context;
	}

	setAggregatorCashOut() {
		this.isAggregatorCashout = true;
	}

	getAggregatorCashOut() {
		return this.isAggregatorCashout;
	}

	destroyPinModal() {
		this._pinModalDestroy.next(true);
	}

	destroyReportModal() {
		this._reportModalDestroy.next(true);
	}

	getContext() {
		return this.userContext;
	}

	setDisplayAccountBalance(balance) {
		this.displayAccountBalance = balance;
	}

	//   getAggregators(): Promise<any> {
	// 	const url = this.config.MONIEPOINT_HOST + `/api/v1/aggregator-requests?pageNumber=1&pageSize=10`;
	// 	return this.apiClientHelper.getForPromise(url);
	// }

	getDisplayAccountBalance() {
		return this.displayAccountBalance;
	}

	setPersistFlag(flag) {
		this.persistFlag = flag;
	}

	getPersistFlag() {
		return this.persistFlag;
	}

	getAggregators(params: AggregatorRequestModel): Promise<AggregatorModel> {
		const urlString = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/super-aggregators/aggregators?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getEligibleAggregators(): Promise<ElligibleAggregatorObjectModel> {
		const url = this.config.MONIEPOINT_AREA + `/api/v2/super-aggregators/eligible-aggregators`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAgents(urlRequest, params): Promise<AggregatorAgentModel> {
		const urlString = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/${urlRequest}?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
  }

  getBusinesses(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/partners-account-creation/workflow?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAggregatorAgents(params): Promise<AggregatorAgentModel> {
		const urlString = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents/by-kyc-verification-status/APPROVED?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAgentDetails(id) {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents/${id}/user-details`;
		return this.apiClientHelper.getForPromise(url);
	}

	getImprovedAgentDetails(id) {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents/details/${id}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getFees(id): Promise<FeesModel> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents/fees?agentId=${id}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getFile(url) {
		// @ts-ignore
		return this.apiClientHelper.getAssetFile(url);
	}

	getAgentTerminalInfo(id): Promise<AgentTerminalInfoModel> {
		const context = this.context;
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/${context}/get-agents-terminals/${id}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAssignedSerialNos(params, agentContext?): Promise<AssignedSerialNoModel> {
		let url;
		const context = this.context;
		const urlParams = StringHelper.toUrlString(params);
		if (agentContext) {
			url = this.config.MONIEPOINT_TERMINAL + `/api/v1/aggregators/assigned-serial-nos`;
		} else {
			url = this.config.MONIEPOINT_HOST + `/api/v1/${context}/assigned-serial-nos?${urlParams}`;
		}
		return this.apiClientHelper.getForPromise(url);
	}

	getAllAgentLocation(id): Promise<AgentLocationModel> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents-location/all/${id}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getRelationships(): Promise<string[]> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/next-of-kin/relationships`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAggregatorCommission(): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/${this.context}/commission`;
		return this.apiClientHelper.getForPromise(url);
	}

	registerAgent(params): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents`;
		return this.apiClientHelper.newPostAsFormDataForPromise(url, params);
	}

	assignTerminal(params: AssignTerminalRequestModel, context?) {
		let url;
		if (context) {
			url = this.config.SHOW_TERMINAL_ASSIGNMENT_UPDATE
				? this.config.MONIEPOINT_TERMINAL + `/api/v2/aggregators/assign/terminal`
				: this.config.MONIEPOINT_TERMINAL + `/api/v2/aggregators/assign/terminal`;
		} else {
			url = this.config.SHOW_TERMINAL_ASSIGNMENT_UPDATE
				? this.config.MONIEPOINT_TERMINAL + `/api/v2/${this.context}/assign/terminal`
				: this.config.MONIEPOINT_TERMINAL + `/api/v1/${this.context}/assign/terminal`;
		}
		return this.apiClientHelper.postForPromise(url, params);
	}

	newAssignTerminal(params: NewAssignTerminalRequestModel, context?) {
		let url;
		if (context) {
			url = this.config.SHOW_TERMINAL_ASSIGNMENT_UPDATE
				? this.config.MONIEPOINT_TERMINAL + `/api/v2/aggregators/assign/terminal`
				: this.config.MONIEPOINT_TERMINAL + `/api/v2/aggregators/assign/terminal`;
		} else {
			url = this.config.SHOW_TERMINAL_ASSIGNMENT_UPDATE
				? this.config.MONIEPOINT_TERMINAL + `/api/v2/${this.context}/assign/terminal`
				: this.config.MONIEPOINT_TERMINAL + `/api/v2/${this.context}/assign/terminal`;
		}
		return this.apiClientHelper.postForPromise(url, params);
	}

	approveTerminalRequest(params: NewAssignTerminalRequestModel, id: any) {
		let url;
		url = this.config.MONIEPOINT_HOST + `/api/v1/pos-requests/${id}/aggregator/approve`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	addLocationToAgent(params: AddLocationRequestModel) {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents-location`;
		return this.apiClientHelper.newPostAsFormDataForPromise(url, params);
	}

	bulkUploadAgents(params: { agentBulkUploadDocument: any }) {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents/import`;
		return this.apiClientHelper.newPostAsFormDataForPromise(url, params);
	}

	getBvnImage(id): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/aggregators/${id}/business/bvn-image`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBRMRank(): Promise<any> {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/pricing-concession-request/brm/rank`;
		return this.apiClientHelper.getForPromise(url);
	}

	getPricingPlansDetails(): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/fixed-pricing-plans`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBusinessPricingPlanDetails(businessId): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pricing-concession-request/agents/${businessId}/pricing-plan-details`;
		return this.apiClientHelper.getForPromise(url);
	}

	createPricingPlanRequest(params): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pricing-concession-request/brm`;
		return this.apiClientHelper.newPostAsFormDataForPromiseMultiFiles(url, params);
	}

	editPricingPlanRequest(params) {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pricing-concession-request/brm`;
		return this.apiClientHelper.newPutAsFormDataForPromiseMultiFiles(url, params);
	}

	deletePricingPlanDocument(documentId) {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pricing-concession-request/brm/documents/${documentId}`;
		return this.apiClientHelper.delete(url);
	}

	getCashoutPeriod(): Promise<CashoutPeriodSummary> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/cashout-period`;
		return this.apiClientHelper.getForPromise(url);
	}

	setCompletedModal(action: number) {
		this.completedModal = action;
	}

	getCompletedModal() {
		return this.completedModal;
	}

	getBRMAccountSummary(): Promise<BrmAccountSummary> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/aggregators/account-summary`;
		return this.apiClientHelper.getForPromise(url);
	}

	getlienOnBRMAccount(params): Promise<any> {
		const urlParams = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/aggregators/liens?${urlParams}`;
		return this.apiClientHelper.getForPromise(url);
	}

  getFVSPendingVerificationCount() {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/fvs/pending-verification-count`;
		return this.apiClientHelper.getForPromise(url);
  }
}
